import React, {
  createContext,
  useContext,
  useCallback,
  useMemo,
  useState,
} from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { chatUrl } from "../../config/chat";

// Mobile navigates same-window to the chat route: an iframe breaks the installed-app webview.
const AiChatContext = createContext({
  isOpen: false,
  isMobile: false,
  openChat: () => {},
  closeChat: () => {},
  toggleChat: () => {},
  provided: false,
});

export const AiChatProvider = ({ children }) => {
  const outer = useContext(AiChatContext);
  const [isOpen, setIsOpen] = useState(false);
  // Match App.js's isMobile so the panel/full-screen split lines up app-wide.
  const isMobile = useMediaQuery("(max-width:640px)");

  const openChat = useCallback(() => {
    if (isMobile) {
      window.location.assign(chatUrl());
      return;
    }
    setIsOpen(true);
  }, [isMobile]);
  const closeChat = useCallback(() => setIsOpen(false), []);
  const toggleChat = useCallback(() => {
    if (isMobile) {
      window.location.assign(chatUrl());
      return;
    }
    setIsOpen((prev) => !prev);
  }, [isMobile]);

  const value = useMemo(
    () => ({ isOpen, isMobile, openChat, closeChat, toggleChat, provided: true }),
    [isOpen, isMobile, openChat, closeChat, toggleChat]
  );

  // An outer provider (PwaShellLayout) already owns the state.
  if (outer.provided) return children;

  return (
    <AiChatContext.Provider value={value}>{children}</AiChatContext.Provider>
  );
};

export const useAiChat = () => useContext(AiChatContext);
